<template>
    <div>
      <!-- <PopUp v-if="showPopup" @closePopup="onClosePopup" /> -->
      <div class="page-content">
        <div class="page-content-2">
            <div class="center-text own-title margin-bottom-20">
              Explore The World
            </div>
            <div class="content">
              <ExploreBanner
                video="explore_the_world/video/Generali Star Convention.mp4"
                modal="star-modal"
                title="Hokkaido"
                title1="Japan"
                menu="menu-star"
                positionSlide2="240px"
                image="star.png"
                description1="Generali Star Convention"
                description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
                description3=""
                link="star"
                
                y1y2agentspvi="140,000"
                agentspvi="180,000"
                leaderpspvi="250,000"
                directunitpvi="540,000"
                grouppvi="1,080,000"
                
                badge="explore_the_world/logo/star.png"
                bannerBadge="star-badge.png"
                />
              <ExploreBanner
                video="explore_the_world/video/Generali Elite Convention.mp4"
                modal="elite-modal"
                title="Paris"
                title1="France"
                menu="menu-elite"
                positionSlide2="145px"
                image="elite.png"
                description1="Generali Elite Convention"
                description2="Qualifying Period: 01 JAN 2026 – 31 DEC 2026"
                description3=""
                link="elite"
      
                y1y2agentspvi="290,000"
                agentspvi="370,000"
                leaderpspvi="520,000"
                directunitpvi="1,110,000"
                grouppvi="2,220,000"

                badge="explore_the_world/logo/elite.png"
                bannerBadge="elite-badge.png"
                />
            </div>
            <div class="divider divider-margins"></div>
        </div>
      </div>
    </div>
</template>
<style scoped>
/* .theme-dark .divider {
    background-color: unset !important;
}
.theme-dark .page-content{
  display: contents;
}
.theme-dark .page-content-2{
  max-width: 1000px;
  margin: 0 auto;

} */
/* .divider-margins {
    margin: 0px 15px 60px 15px;
}
.content {
    margin: 0px 0 20px 0 !important;
} */
/* .mb-10 {
  margin-bottom: 10px;
} */
</style>
<script>
// import PopUp from '../components/PopUp.vue'
import ExploreBanner from '../components/ExploreBanner.vue'
export default {
  name: 'Explore',
  components: {
    ExploreBanner,
    // PopUp,
  },
  // data() {
  //     return {
  //       showPopup: true,
  //     };
  // },
  // methods: {
  //   onClosePopup() {
  //     this.showPopup = false;
  //   },
  // },
  mounted(){
      document.querySelector(".header-s").style.display = "block";
      document.querySelector(".header").style.zIndex = "96";
  },
}
</script>
